var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-page"},[_c('div',{staticClass:"dev-page__wrapper"},[_c('OrdersReworkTab',{attrs:{"rework-properties":_vm.getProperties}}),_c('hr'),_c('br')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }